angular.module('impactx').service('DeeplinkService', [
    'cookieService',
    DeeplinkService]);

function DeeplinkService(cookieService) {

    this.deepLink = undefined;

    this.storeDeeplink = function(deeplink) {
        if(!this.deepLink && deeplink.length > 1 && deeplink.indexOf('login') && deeplink.indexOf('s-login') < 0
            && deeplink.indexOf('/custom/') < 0 && deeplink.indexOf('/s-custom/') < 0) {
            this.deepLink = deeplink;
            cookieService.setCookie("deepLink", deeplink, 1);
        }
    };

    this.getRecentDeeplink = function() {
        var result;
        if(this.deepLink) {
            result = this.deepLink;
        }
        else{
            result = cookieService.getCookieValue("deepLink");
        }
        return result;
    };

    this.deleteRecentDeeplink = function() {
        this.deepLink = undefined;
        cookieService.removeCookie("deepLink");
    };

    this.storeOsuTan = function(osuTan) {
        if(osuTan.length > 0) {
            this.osuTan = osuTan;
            cookieService.setCookie("osuTan", osuTan, 1);
        }
    };

    this.getRecentOsuTan = function() {
        var result;
        if(this.osuTan) {
            result = this.osuTan;
        }
        else{
            result = cookieService.getCookieValue("osuTan");
        }
        return result;
    };

    this.deleteRecentOsuTan = function() {
        this.osuTan = undefined;
        cookieService.removeCookie("osuTan");
    };

    return {
        getRecentDeeplink: this.getRecentDeeplink,
        deleteRecentDeeplink: this.deleteRecentDeeplink,
        storeDeeplink: this.storeDeeplink,
        getRecentOsuTan: this.getRecentOsuTan,
        deleteRecentOsuTan: this.deleteRecentOsuTan,
        storeOsuTan: this.storeOsuTan
    };
}